import { CardContent as MCardContent, CardContentProps } from '@mui/material'

export const CardContent: React.FC<CardContentProps> = (props) => {
  return <MCardContent {...props} />
}
